<template>
  <swiper
    :slidesPerView="1"
    :spaceBetween="30"
    :slidesPerGroup="1"
    :pagination="{
      clickable: true,
    }"
    :breakpoints="{
      '400': {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      '767': {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    }"
    :navigation="true"
    :modules="modules"
    class="trainers-swiper"
  >
    <swiper-slide>
      <div class="img">
        <img src="../assets/imgs/trainer.jpg" alt="">
      </div>
      <h1>Alexia</h1>
      <h3>GYM</h3>
    </swiper-slide>
    <swiper-slide>
      <div class="img">
        <img src="../assets/imgs/trainer.jpg" alt="">
      </div>
      <h1>Alexia</h1>
      <h3>YOGA</h3>
    </swiper-slide>
    <swiper-slide>
      <div class="img">
        <img src="../assets/imgs/trainer.jpg" alt="">
      </div>
      <h1>Alexia</h1>
      <h3>BOXING</h3>
    </swiper-slide>
    <swiper-slide>
      <div class="img">
        <img src="../assets/imgs/trainer.jpg" alt="">
      </div>
      <h1>Alexia</h1>
      <h3>GYM</h3>
    </swiper-slide>
    <swiper-slide>
      <div class="img">
        <img src="../assets/imgs/trainer.jpg" alt="">
      </div>
      <h1>Alexia</h1>
      <h3>YOGA</h3>
    </swiper-slide>
    <swiper-slide>
      <div class="img">
        <img src="../assets/imgs/trainer.jpg" alt="">
      </div>
      <h1>Alexia</h1>
      <h3>BOXING</h3>
    </swiper-slide>
  </swiper>
</template>
<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

// Import Swiper styles
import "swiper/css";

import "swiper/css/pagination";
import "swiper/css/navigation";

// import required modules
import { Pagination, Navigation } from "swiper";

export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      modules: [Pagination, Navigation],
    };
  },
};
</script>
